import { defaultLabels } from "./defaultLabels"

export const fallbackContent = {
  game_intro: {
    host_intro_slides: [
      {
        title: defaultLabels.GAME_INTRO_HOST_FALLBACK_TITLE,
        description: defaultLabels.GAME_INTRO_HOST_FALLBACK_DESCRIPTION,
      },
    ],
  },
  game_outro: {
    host_outro_slides: [
      {
        title: defaultLabels.GAME_OUTRO_HOST_FALLBACK_TITLE,
        description: defaultLabels.GAME_OUTRO_HOST_FALLBACK_DESCRIPTION,
      },
    ],
    host_outro_results_button: defaultLabels.GAME_OUTRO_HOST_RESULTS_BUTTON,
    host_results_title: defaultLabels.GAME_OUTRO_GUEST_RESULTS_BUTTON,
  },
  round_intro: {
    host_slides: [
      {
        title: defaultLabels.ROUND_INTRO_HOST_FALLBACK_TITLE,
        description: defaultLabels.ROUND_INTRO_HOST_FALLBACK_DESCRIPTION,
      },
    ],
  },
  round_outro: {
    host_slides: [
      {
        title: defaultLabels.ROUND_OUTRO_HOST_FALLBACK_TITLE,
        description: defaultLabels.ROUND_OUTRO_HOST_FALLBACK_DESCRIPTION,
      },
    ],
  },
}
